import React from 'react';
import { Link } from 'react-router-dom';
import './CategoryCard.css';

/**
 * CategoryCard Component
 * Display card for help center categories with icon
 */
const CategoryCard = ({ title, description, route, icon: Icon }) => {
  return (
    <Link to={route} className="category-card">
      {Icon && (
        <div className="category-card-icon">
          <Icon weight="regular" size={20} />
        </div>
      )}
      <h3 className="category-card-title">{title}</h3>
      <p className="category-card-description">{description}</p>
    </Link>
  );
};

export default CategoryCard;
